/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BreadcrumbLink } from '@squiz/sds';
import { useDxpFrameStore } from 'dxpConsoleCore-mf/State';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DxpCapability } from '../../Constants/DxpCapabilities/defs/DxpCapability.defs';
import { CORE_STRINGS } from '../../Constants/Strings.constants';
import { replaceTenantParam } from '../../Utilities/ReplaceTenantParam/ReplaceTenantParam';

/**
 * React hook to get a generated list of breadcrumb links for a capability screen.
 */
export const useCapabilityBreadcrumbs = (nameOverride?: string): Array<BreadcrumbLink> => {
  const { t } = useTranslation();
  const { capability }: { capability: DxpCapability | null } = useDxpFrameStore();

  // Labels
  const labels = useMemo(() => {
    return {
      home: t(CORE_STRINGS.home),
    };
  }, [t]);

  // Build out links based on capability
  if (capability && capability.path) {
    const capabilityName = nameOverride || capability.title;

    // If there's a path, a prefix will exist.
    // Find the home path based on everything before the prefix.
    const capabilityPath = replaceTenantParam(capability.path);
    const capabilityPrefix = capability.prefix as string;
    const homePath = capabilityPath.split(`/${capabilityPrefix}`)[0];

    return [
      { name: labels.home, url: homePath },
      { name: capabilityName, url: capabilityPath },
    ];
  }

  // If there is no capability, don't return any links
  return [];
};
